import functions from "./functions.js";
import lozad from 'lozad';

const $window = $(window);

const details = {
    $details: null,
    details: null,
    unitId: 0,
    publicId: 0,
    currencyIdTo: 0,
    cntShowPrices: 0,
    response: null,
    lang: functions.getLang(),
    $bookRange: null,
    fromText: null,
    toText: null,
    tooltipText: null,
    firstSelectedDate: null,
    dateFromModal: null,
    dateToModal: null,
    $form: null,
    form: null,
    $formPersons: null,
    //formPersons: null,
    minDate: null,
    maxDate: null,
    data: {
        dateFrom: null,
        dateTo: null,
        persons: 2
    },
    params: {},

    init() {

        details.$wrapper = $('.page-type-details');
        details.wrapper = details.$wrapper[0];

        details.$form = $('.form-availability');
        details.form = details.$form[0];

        if (!details.wrapper) {
            return;
        }

        let $bookingWrapper = $('#booking');
        let unitId = $bookingWrapper.attr('data-unitid');
        details.unitId = $bookingWrapper.attr('data-unitid');
        details.publicId = $bookingWrapper.attr('data-objectid');
        details.bookingUrl = $bookingWrapper.attr('data-bookingurl');
        details.minDate = $bookingWrapper.attr('data-mindate');
        details.maxDate = $bookingWrapper.attr('data-maxdate');
        details.currencyIdTo = functions.getCookie('currencyIdTo') ? functions.getCookie('currencyIdTo') : 1;

        // google map
        const $map = $('.od-map');
        if ($map.length) {
            let map;
            let mapTimeout;
            // check if in viewport
            if ($map[0].getBoundingClientRect) {
                $window.on('load, scroll', e => {
                    if (map) {
                        return;
                    }
                    clearTimeout(mapTimeout);
                    mapTimeout = setTimeout(() => {
                        let screenHeight = document.documentElement.clientHeight;
                        let mapBounds = $map[0].getBoundingClientRect();
                        if (screenHeight > mapBounds.top && mapBounds.bottom > 0) {
                            window.loadGoogleMaps();
                        }
                    }, 1000);
                });
            } else {
                $window.on('load', e => window.loadGoogleMaps());
            }
            // map init
            $window.on('gMapsLoaded', e => {
                let center;
                let isMarker;
                try {
                    center = JSON.parse($map.attr('data-lat-lng'));
                    isMarker = JSON.parse($map.attr('data-marker'));
                } catch (e) { }

                if (center) {
                    map = new google.maps.Map($map[0], {
                        center: center,
                        zoom: 12
                    });
                    if (isMarker) {
                        new google.maps.Marker({
                            map: map,
                            position: center
                        });
                    } else {
                        new google.maps.Circle({
                            map: map,
                            center: center,
                            radius: 600, // 10 miles in metres
                            fillColor: '#1B2452',
                            strokeOpacity: 0.8
                        });
                    }
                }
            });
        }
        // end google map


        // init form set
        details.getDefaults();
        details.getParams();
        functions.setFormData(details.form, details.data);
        details.getCalculation(unitId);

        // form change push to url
        details.$form.on('change', e => {
            functions.setUrlData(functions.getFormData(details.$form), true);
            details.getParams();
        });

        // for cruises
        if ($('.booking-item').length > 0) {
            details.setPrices();
            $(window).on('hashchange', details.setPrices);
        }

        details.$formPersons = $('.form-persons');
        details.getCalculationForCabins();

        // cruise persons form change
        details.$formPersons.on('change', e => {
            details.getCalculationForCabin($(e.currentTarget));
        });

        // instance of cruise units slider
        let $unitSlider = null;

        $('.collapse').on('hide.bs.collapse', e => {
            if ($unitSlider.length) {
                $unitSlider.destroy();
            } 
        });

        $('.collapse').on('show.bs.collapse', e => {

            $unitSlider = $(e.target).find('.excursion-unit-detail');

            if ($unitSlider.length) {
                $unitSlider.lightSlider({
                    item: 3,
                    slideMargin: 2,
                    loop: false,
                    auto: false,
                    pager: false,
                    enableDrag: false,
                    controls: true,
                    prevHtml: '<i class="las la-angle-left text-white p-1 rounded" style="font-size: 1.8rem; background-color: #393844cc;"></i>',
                    nextHtml: '<i class="las la-angle-right text-white p-1 rounded" style="font-size: 1.8rem; background-color: #393844cc;"></i>',
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                item: 2
                            }
                        },
                        {
                            breakpoint: 1000,
                            settings: {
                                item: 1
                            }
                        }
                    ]
                });
            }


        });

        // react to url and do calc
        //$(window).on('hashchange', details.getCalculation(unitId));
        $(window).on('hashchange', e => {
            if (details.$formPersons.length) {
                details.getCalculationForCabins();
            } else {
                details.getCalculation(unitId);
            }
        });

        $('.btn-booking').on('click', e => {
            e.preventDefault();

            // cruises
            if ($(e.currentTarget).attr('data-id')) {
                details.unitId = $(e.currentTarget).attr('data-id');
            }

            if ( $('.cruise-period').length ) {
                details.data.dateTo = $('.cruise-period[value="' + details.data.dateFrom + '"]').attr('data-date-to');
            }

            var params = $.param({ 
                publicId: details.publicId,
                unitId: details.unitId,
                objectGroupId: details.data.objectGroupId,
                dateFrom: details.data.dateFrom,
                dateTo: details.data.dateTo,
                persons: details.data.persons
            });
            
            location = $(e.currentTarget).attr('data-url') + '?' + params;

        })


    },
    // set unit prices for cruise
    setPrices() {

        let allPrices = JSON.parse($('.base-prices-units').attr('data-basepricesunits'));

        $('.d-none').removeClass('d-block');

        //$('.spinner').removeClass('d-none');

        let 
            unitId = null,
            dateFrom = null,
            price = null,
            percent = null,
            calcPrice = null;

        Object.values(allPrices).forEach(function (item) {
            
            unitId = item['unitId']['id'];
            dateFrom = item['dateFrom'];
            details.data.dateTo = item['dateTo'];
            
            if (details.data['dateFrom'] == dateFrom) {

                price = item['price'];
                percent = item['percent'];
                calcPrice = percent ? price - (price * percent / 100) : null;

                //details.data.unitId = unitId;

                details.params = functions.getUrlData(true);
                details.params.unitId = unitId;
                details.params.objectGroupId = details.data.objectGroupId;

                $('.price-unitID-' + unitId)
                    .text(functions.formatMoney(calcPrice ? calcPrice : price, 2, ',', '.'));
                
                $('.discounted-unitID-' + unitId)
                    .text(calcPrice ? functions.formatMoney(price, 2, ',', '.') : null);

                $('#' + unitId).addClass('d-block');
            }
            
        });

    },
    getDefaults() {
        let defaults = $('.form-availability').attr('data-params');
        defaults = defaults ? JSON.parse(defaults) : {};
        details.data = $.extend({}, details.data, defaults);
    },
    getParams() {
        $.extend(details.data, functions.getUrlData(true));
    },
    // calculation for accommodation booking
    getCalculationForCabins() {
        details.$formPersons.each((i, item) => {
            details.getCalculationForCabin(item);
        });
    },
    getCalculationForCabin(item) {
        details.unitId = $(item).attr('data-unitid');
        details.data.persons = $(item).find('.details-unit-persons').val();

        if ($('.cruise-period').length) {
            details.data.dateTo = $('.cruise-period[value="' + details.data.dateFrom + '"]').attr('data-date-to');
        }
        details.getCalculation(details.unitId);
    },
    getCalculation(unitId) {
        let showCharterAlert = false;
        details.getParams();

        //console.log('unitId', unitId);

        //if(unitId != null) details.unitId = unitId;

        //console.log(details.unitId);

        unitId = unitId ? unitId : details.unitId;

        if ( ! (details.data.dateFrom && details.data.dateTo && details.data.persons)) {
            $('.calculated-price').text('-,--' + ' €');
            return;
        }

        return $.getJSON(
            location.protocol
            + '//'
            + location.hostname
            + '/services/calc.php'
                + '?unitId=' + unitId
            //+ '&guests=' + '2,0'
            + '&persons=' + details.data.persons
            + '&dateFrom=' + details.data.dateFrom
            + '&dateTo=' + details.data.dateTo
            + '&objectGroupId=' + details.data.objectGroupId
        )
            .done(function (response) {
                details.response = response;

                //console.log(details.unitId);
                //console.log(details.response.data)
                //console.log(details.response.data[unitId])

                const lang = details.lang;

                const responseStatus = details.response.status;
                //const responseData = unitId ? details.response.data[unitId] : details.response.data[details.unitId];
                //console.log('test', unitId)
                //console.log('test2', details.response.data)
                const responseData = details.response.data[unitId];
                //console.log(responseData);
                const bookingStatus = responseStatus ? responseData.booking.status : null;

                $('.btn-booking-object').removeClass('disabled');
                $('.unavailable-booking').removeClass('d-flex justify-content-end');

                if (responseStatus)
                {
                    let total = responseData.calc.total;
                    let isBookable = bookingStatus == 'Request' || bookingStatus == 'Reservation';
                    let $excursionUnit = $('#unit'+unitId);
                    total = functions.formatMoney(total, 2, ',', '.');
                    //console.log(unitId);
                    //console.log(total);

                    $('.calculated-price').text((isBookable ? total : '-,--') + ' €');

                    $excursionUnit.find('.details-unit-total-' + unitId).text(isBookable ? total : '-,--');
                    $excursionUnit.find('.details-unit-total-charge-' + unitId).toggleClass('d-none', details.data.persons != 1);
                    $excursionUnit.find('.btn-excursion[data-id="'+unitId+'"]').toggleClass('disabled', ! isBookable).prop('disabled', ! isBookable);
                    $excursionUnit.find(".charged-text").toggleClass('d-none', ! isBookable);
                    $excursionUnit.find(".unavailable-booking").toggleClass('d-none', isBookable);

                    if (bookingStatus)
                    {
                        let output = '';

                        switch (bookingStatus) {
                            case 'Request': {
                                output = lang == 'hr' ? 'Pošalji upit' : (lang == 'de' ? 'Anfrage absenden' : 'Send enguiry');
                                $('.availability-button').text(output);
                                $('.btn-booking-object').removeClass('disabled');
                                showCharterAlert = true;
                                break;
                            }
                            case 'Reservation': {
                                output = lang == 'hr' ? 'Rezerviraj' : (lang == 'de' ? 'Buchung' : 'Booking');
                                $('.availability-button').text(output);
                                $('.btn-booking-object').removeClass('disabled');
                                showCharterAlert = true;
                                break;
                            }
                            case 'Unavailable': {
                                $('.btn-booking-object').addClass('disabled');
                                $('.unavailable-booking').addClass('d-flex justify-content-end');
                                break;
                            }
                        }

                    }
                }



                $(".charter-alert").toggleClass('d-none', ! (details.data.objectGroupId == 3 && showCharterAlert));
            });
    }
}


$(() => {
    details.init();
});